import { render } from "./ThazeMaze.vue?vue&type=template&id=514b1bf2"
import script from "./ThazeMaze.vue?vue&type=script&lang=js"
export * from "./ThazeMaze.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__